/**
 * Component Registry for McKinney Village
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-theme-blue-haven and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-theme-blue-haven/registry';
import DallasMavericksGames from './components/DallasMavericksGames';
import Header from './components/Header';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  DallasMavericksGames,
  Header,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
